import React from "react";
import Section from "@/components/Section/section";
import Components from "@/components/components";
import SbEditable from "storyblok-react";
import styles from "./section.module.scss";
import classnames from "classnames";
import SectionItem from "./section-item";
import { PricingBillingProvider } from "@/components/PricingBillingContext";
import { SectionStoryblok } from "@/types/component-types-sb";

interface Props {
  blok: SectionStoryblok;
  className?: string;
}

const SbSection = (props: Props) => {
  const classes = classnames(
    styles[props.blok.padding_top || ""],
    styles[props.blok.padding_bottom || ""],
    props.className
  );

  const content = props?.blok?.content || [];

  const firstExplorer = content.find(
    (blok) => (blok.component as string) === "pricing-explorer"
  );
  const hasComparisonTable = content.some(
    (blok) => (blok.component as string) === "pricing-comparison-table"
  );
  const needsBillingSync = !!firstExplorer && hasComparisonTable;

  const renderedChildren = content.map((blok) => (
    <SectionItem key={blok._uid} {...blok} className={blok.component}>
      {React.createElement(Components(blok.component), {
        blok,
      })}
    </SectionItem>
  ));

  return (
    // @ts-expect-error
    <SbEditable content={props.blok}>
      <Section {...props.blok} className={classes} name={props.blok.name}>
        {needsBillingSync ? (
          <PricingBillingProvider
            defaultBilling={firstExplorer?.default_billing}
          >
            {renderedChildren}
          </PricingBillingProvider>
        ) : (
          renderedChildren
        )}
      </Section>
    </SbEditable>
  );
};

export default SbSection;
